<template>
  <div class="breadcrumb">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/' }">Главная</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: two.path }" v-if="two">{{two.name}}</el-breadcrumb-item>
      <el-breadcrumb-item v-if="three">{{three}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: "Breadcrumbs",
  props: [
    'two',
    'three'
  ]
}
</script>

<style scoped>

</style>
